import { Usuario } from './../models/usuario';
import { environment as env} from './../../../environments/environment';
import { Observable } from 'rxjs';
import { AuthenticationService } from './authentication/authentication.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { retry, catchError, delay } from 'rxjs/operators';
import { BaseService } from './base/service.base';
//import { API } from 'src/api';

@Injectable({
  providedIn: 'root',
})
export class LoginService extends BaseService {
private readonly PATH = '/login';
private readonly PATH_CADU_AUTO = '/Login/CADU/auto';
private readonly PATH_CADU = '/Login/CADU';
private readonly PATH_CADU_GESTOR = '/Login/Gestor';
private readonly PATH_CADU_INSERT_BEM = '/Login/CADUINSERTBEM';
private readonly PATH_LOT = '/Login/lotacao';
private readonly PATH_GESTOR = '/Login/Gerentes';
private readonly PATH_SUBORDINADOS = '/Login/CADU/Subordinados';
  constructor(
    public http: HttpClient,
    public authenticationService: AuthenticationService) {
      super(http, authenticationService);
    }
    autenticar(usuario:Usuario): Observable<any> {
      //console.log/usuario);
      return this.http
        .post(env.baseurl + this.PATH, usuario,{responseType:'text'})
        .pipe(retry(1), catchError(this.errorHandl));
    }
    getAll():Observable<any>{
      return this.http.get(env.baseurl + this.PATH_CADU)
    }

    getCADUInsertBem():Observable<any>{
      return this.http.get(env.baseurl + this.PATH_CADU_INSERT_BEM)
    }
    getAuto():Observable<any>{
      return this.http.get(env.baseurl + this.PATH_CADU_AUTO).pipe(delay(1000))
    }
    getLot():Observable<any>{
      return this.http.get(env.baseurl + this.PATH_LOT)
    }
    getGestor():Observable<any>{
      return this.http.get(env.baseurl + this.PATH_GESTOR);
    }
    authGestor():Observable<any>{
      return this.http.get(env.baseurl + this.PATH_CADU_GESTOR);
    }
    getSubordinado():Observable<any>{
      return this.http.get(env.baseurl + this.PATH_SUBORDINADOS);
    }
}
